/* Collection card image strip: arrows for the scroll-snap rows (see ts-card-slider.css).
   One delegated listener for the whole grid; nothing is initialised per card, and cards added
   later by "load more" or a filter work without any call. */
(function () {
  if (window.__tsCardSlider) return;
  window.__tsCardSlider = true;

  var USER_WINDOW = 2500; // ms after a touch/wheel/arrow during which strip scrolling is the shopper's

  function strip(el) {
    return el && el.closest ? el.closest('.ts-snap') : null;
  }
  function markUser(s) {
    if (s) s.__tsUser = Date.now();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ts-snap-arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.ts-snap-wrap');
    var s = wrap && wrap.querySelector('.ts-snap');
    if (!s) return;
    var dir = parseInt(btn.getAttribute('data-dir') || '1', 10);
    var w = s.clientWidth || 1;
    var max = s.scrollWidth - w;
    var idx = Math.round(s.scrollLeft / w);
    var next = idx + dir;
    var count = Math.round(s.scrollWidth / w);
    if (next < 0) next = count - 1;          // wrap around, like the infinite slider it replaces
    if (next * w > max + 1) next = 0;
    markUser(s);
    s.__tsIdx = next;
    s.scrollTo({ left: next * w, behavior: 'smooth' });
  }, true);

  /* Keep each strip on the photo the shopper chose. Some phone browsers re-snap horizontal
     scroll-snap strips on their own when the page relays out (address bar collapsing while
     scrolling, lazy images arriving), which can leave a card on its second photo although nobody
     swiped. A strip scroll that was not preceded by a touch, wheel or arrow on that strip is put
     back where it was; the shopper's own swipes are remembered as the strip's slide index. */
  var opts = { capture: true, passive: true };
  document.addEventListener('touchstart', function (e) { markUser(strip(e.target)); }, opts);
  document.addEventListener('pointerdown', function (e) { markUser(strip(e.target)); }, opts);
  document.addEventListener('wheel', function (e) { markUser(strip(e.target)); }, opts);

  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains('ts-snap')) return;
    var w = s.clientWidth || 1;
    if (Date.now() - (s.__tsUser || 0) < USER_WINDOW) {
      clearTimeout(s.__tsTimer);
      s.__tsTimer = setTimeout(function () { s.__tsIdx = Math.round(s.scrollLeft / w); }, 150);
      return;
    }
    var want = (s.__tsIdx || 0) * w;
    if (Math.abs(s.scrollLeft - want) > 1) s.scrollLeft = want;
  }, true);
})();
